import { config } from './utils'
import { httpClient } from 'utils/http'

import API from 'settings/api.settings'

export const profile = () => ({
  get: () =>
    httpClient.get(`${API.baseUrl}/v1/operators/operator/me/`, config()),
})
